module.exports = __webpack_public_path__ + "static/media/je.55d15529.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/je.svg
// module id = 679
// module chunks = 0